import { Validators } from '@angular/forms';
import CustomValidators, { strictEmailValidator } from '../custom-validators.model';

export const USERINFO_FORM_CONTROL_VALIDATORS = {
  emailRu: [Validators.required, CustomValidators.emailValidator],
  email: [Validators.required, strictEmailValidator],
  inn: [Validators.required, CustomValidators.onlyNum, CustomValidators.commonInnLen],
  ogrn: [Validators.required, CustomValidators.onlyNum, CustomValidators.ogrnLen],
};
